<form (submit)="saveCustomer($event)" [formGroup]="customerForm">
  <h2 mat-dialog-title>{{ 'CREATE_CUSTOMER' | translate }}</h2>

  <mat-dialog-content class="create-customer">
    <i class="txt-gray">
      {{ 'CREATE_USER_TEXT1' | translate }}
      <br />
      {{ 'CREATE_USER_TEXT2' | translate }}
    </i>

    <div class="margin-top">
      <mat-form-field>
        <mat-label>{{ 'EMAIL' | translate }}</mat-label>
        <input matInput type="text" formControlName="Email" required />
        <mat-error>{{ 'PROVIDE_VALID_EMAIL' | translate }}</mat-error>
      </mat-form-field>
    </div>
    @if (!whiteLabelInstance.whitelabelID) {
      <div>
        <div *canSee="userType.Support">
          <!--OPERATOR-->
          <mat-form-field>
            <mat-label>{{ 'WHITELABEL_OPERATOR' | translate }}</mat-label>
            <input type="text" matInput formControlName="Operator" [matAutocomplete]="operatorAuto" name="Operator" />
            @if (customerForm.value.Operator) {
              <button matTextSuffix mat-icon-button type="button" (click)="clearOperator()">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
          <mat-autocomplete #operatorAuto="matAutocomplete" [displayWith]="displayFnOperator.bind(this)">
            @for (operator of filteredOperators | async; track operator) {
              <mat-option [value]="operator">
                <span [innerHTML]="operator.Name | highlight: operatorSearchVal"></span>
              </mat-option>
            }
          </mat-autocomplete>
        </div>
      </div>
    }
    <!--<div>
    <mat-form-field>
      <input matInput placeholder="First name" type="text" formControlName="FirstName">
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <input matInput placeholder="Last name" type="text" formControlName="LastName">
    </mat-form-field>
  </div>-->
    @if (!redirectToApp) {
      <div>
        <mat-form-field>
          <input matInput placeholder="{{ 'PHONE' | translate }}" type="text" formControlName="PhoneNumber" />
        </mat-form-field>
      </div>
    }
    <div>
      <mat-form-field>
        <mat-select placeholder="{{ 'LANGUAGE' | translate }}" formControlName="Language" required>
          @for (language of languages; track language.Key) {
            <mat-option [value]="language.Key">
              {{ language.LanguageName }}
            </mat-option>
          }
        </mat-select>
        <mat-error>{{ 'PLEASE_SELECT_A_LANGUAGE' | translate }}</mat-error>
      </mat-form-field>
    </div>
    @if (showRedirectOption) {
      <div class="margin-vertical" matTooltip="{{ 'CREATE_CUSTOMER_TEXT_16' | translate }}">
        <mat-radio-group formControlName="RedirectToApp">
          <mat-radio-button [value]="true" class="margin-right">
            {{ 'END_USER' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="false">
            {{ 'PORTAL_USER' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" type="submit">
      {{ 'CREATE' | translate }}
    </button>
    <button mat-raised-button mat-dialog-close type="button">
      {{ 'CLOSE' | translate }}
    </button>
  </mat-dialog-actions>
</form>
